import { Author } from '@/lib/graphql/generated/graphql';
import type { TFunction } from 'i18next';

export const UNKNOWN_AUTHOR_NAME = 'Unknown';

/**
 * Helper pour obtenir le nom d'affichage de l'auteur
 * Retourne le nom, l'email, l'id ou '-' par défaut
 */
export function getAuthorDisplayName(
  author: Author | null | undefined,
  t?: TFunction
): string {
  if (!author) return '-';
  if (author.name === UNKNOWN_AUTHOR_NAME) {
    return t
      ? t('general.unknown_author', { defaultValue: UNKNOWN_AUTHOR_NAME })
      : UNKNOWN_AUTHOR_NAME;
  }
  return author.name || author.email || author.id || '-';
}
